import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HardHat } from "lucide-react";
import { api } from "../lib/api";

/**
 * SmartLogo — on auth pages (Login, SignUp, ForgotPassword, ResetPassword).
 * Clicking it goes to /dashboard if the user is already logged in, or / otherwise.
 * The check is async; the link defaults to "/" until it resolves (no layout shift).
 */
export default function SmartLogo() {
  const [to, setTo] = useState("/");

  useEffect(() => {
    api.get("/auth/me")
      .then(() => setTo("/dashboard"))
      .catch(() => setTo("/"));
  }, []);

  return (
    <Link to={to} data-testid="smart-logo-link" className="flex items-center gap-2">
      <div className="w-8 h-8 bg-amber-500 rounded-sm flex items-center justify-center">
        <HardHat size={18} className="text-zinc-950" />
      </div>
      <div>
        <div className="font-display font-bold tracking-tight text-base leading-none">Builder's Binder</div>
        <div className="label-eyebrow mt-1">Build Smarter</div>
      </div>
    </Link>
  );
}
